export default "__VITE_ASSET__2fb4a01a__"